import React, { useEffect, useState } from 'react';

import { setBrazeIamSlideupRenderer } from 'apps/auth/analytics/braze';
import BrazeIamSlideup from 'apps/auth/components/braze/BrazeIamSlideup';

const BrazeIamSlideupHost = () => {
    const [slideup, setSlideup] = useState(null);

    useEffect(() => {
        if (!__isBrowser__) {
            return undefined;
        }
        setBrazeIamSlideupRenderer((config, handlers) => setSlideup({ config, handlers }));
        return () => setBrazeIamSlideupRenderer(null);
    }, []);

    if (!slideup) {
        return null;
    }

    return (
        <BrazeIamSlideup
            config={slideup.config}
            onBodyClick={() => {
                slideup.handlers.onPrimaryClick();
                setSlideup(null);
            }}
            onClose={() => setSlideup(null)}
        />
    );
};

export default BrazeIamSlideupHost;
